module.exports = {
      id: "crime-usage",
      viewBox: "0 0 69.07 72.614",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#crime",
      toString: function () {
        return this.url;
      }
    }